export const setLocalRecentPlaces = (data) => {
  localStorage.setItem(
    'recentPlaces',
    JSON.stringify(data)
  )
}
